import { getVipInfo } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

type IModule = 'tool_tab' | 'tool_vip_toolmenu';
type IAction = 'click' | 'show';

export function vipTabReport(module: IModule, action: IAction, ver7?: string) {
    const obj = {
        opername: 'doc_vip_detail',
        module,
        action,
        ver5: getVipInfo(),
        ver6: 'slide',
    };

    if (ver7) {
        Object.assign(obj, { ver7 });
    }
    tdw(obj);
}
